import { useCallback, useContext } from 'react';
import { FormStateContext } from '|/context';

const useLoad = () => {
  const { startLoad, endLoad, setLoadError } = useContext(FormStateContext);

  const load = useCallback(
    async (promise: Promise<void>, signal?: AbortSignal): Promise<void> => {
      startLoad();
      try {
        await promise;
      } catch (errorFromLoad) {
        if (
          signal?.aborted ||
          (errorFromLoad instanceof Error && errorFromLoad.name === 'CanceledError')
        ) {
          return;
        }
        setLoadError(errorFromLoad);
        throw errorFromLoad;
      } finally {
        endLoad();
      }
    },
    [startLoad, endLoad, setLoadError]
  );

  return load;
};

export default useLoad;
